import React from 'react';
import Section from '../Section';
import { HeartIcon, AnnotationIcon, ClipboardCheckIcon, BadgeCheckIcon, CurrencyEuroIcon, WifiIcon } from '@heroicons/react/outline'
import { BiTargetLock, BiHappy, BiBrain  } from 'react-icons/bi'
import { MdOutlineHealthAndSafety } from 'react-icons/md'


function PatientBenefitsV2() {

  const features = [
    {
      name: 'Oral health integration',
      description:
        'Long-term & sustainable solutions.',
      icon: HeartIcon,
    },
    {
      name: 'High precision process',
      description:
        '3D scanners & AI technologies that maximize accuracy.',
      icon: BiTargetLock,
    },
    {
      name: 'Minimally invasive',
      description:
        'Technology that helps retain healthy tooth structure.',
      icon: MdOutlineHealthAndSafety,
    },
    {
      name: 'Comfort and efficiency',
      description:
        'Lesser anesthesia and medications. Fewer visits.',
      icon: BiHappy,
    },
    {
      name: 'Consistent and predictable',
      description:
        'Outcomes that are reliable and less operator-dependent.',
      icon: ClipboardCheckIcon,
    },
    {
      name: 'Excellent aesthetics',
      description:
        'Cosmetic dentistry experts and master ceramists.',
      icon: BadgeCheckIcon,
    },
    {
      name: 'Easier and affordable',
      description:
        'An uncomplicated dental journey and cheaper treatment.',
      icon: CurrencyEuroIcon,
    },
    {
      name: 'Connectivity to platform',
      description:
        'Log in to view your scans and appointments and enjoy a fully digital experience.',
      icon: WifiIcon,
    },
    {
      name: 'Proprietary AI solutions',
      description:
        'Chairside AI-assistance for preparations and placements.',
      icon: BiBrain,
    },
  ]

  return (
    <Section title="Patient Benefits" className="px-0 sm:px-4 2xl:px-20 pb-12 items-center" id="PatientBenefits">
      <div className="pt-8 px-32">
       
        <dl className="space-y-10 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-20">
          {features.map((feature) => (
            <div key={feature.name}>
              <dt>
                <div className="flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white">
                  <feature.icon className="h-7 w-7" aria-hidden="true" />
                </div>
                <p className="mt-5 text-lg leading-6 font-medium text-primary">{feature.name}</p>
              </dt>
              <dd className="mt-2 text-base text-gray-500">{feature.description}</dd>
            </div>
          ))}
        </dl>
      </div>
    </Section>
  );
}

export default PatientBenefitsV2;
